/**
 * Environment config selector — driven by APP_ENV set by host app build mode.
 * Mirrors the web app approach: no hostname/domain-based environment detection.
 *
 * Usage: import { environment } from '@src/config';
 */

import { environment as localEnv } from './environment';
import { environment as devEnv } from './environment.dev';
import { environment as intEnv } from './environment.int';
import { environment as stageEnv } from './environment.stage';
import { environment as prodEnv } from './environment.prod';
import type { Environment } from './environment';

const appEnvRaw = (process.env.APP_ENV as string | undefined)?.toLowerCase() ?? 'local';

const envMap: Record<string, Environment> = {
  local: localEnv,
  dev: devEnv,
  test: intEnv,
  int: intEnv,
  stage: stageEnv,
  prod: prodEnv,
};

export const environment: Environment = envMap[appEnvRaw] ?? localEnv;

export type { Environment };
export { apiUrls } from './api-urls';
